import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import * as moment from 'moment';

interface statementDate{
  startDate: moment.Moment; 
  endDate: moment.Moment; 
}

@Component({
  selector: 'app-medical-statement-dialog',
  templateUrl: './medical-statement-dialog.component.html',
  styleUrls: ['./medical-statement-dialog.component.scss']
})
export class MedicalStatementDialogComponent extends BaseComponent implements OnInit {
  statementForm!: FormGroup;
  patient: any;
  datePicker!: statementDate;
  selectedDateRange: string = '30'; // Default to 30 days
  maxDate: moment.Moment = moment();

  constructor(
    public dialogRef: MatDialogRef<MedicalStatementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    fs: FeedbackService,
    md: MatDialog,
  ) {
    super(fs, md);
  }

  ngOnInit(){
    this.initForm();
    // Set default date range to 30 days
    this.setDateRange('30');
  }

  setDateRange(range: string) {
    this.selectedDateRange = range;
    const endDate = moment();
    let startDate: moment.Moment;

    switch (range) {
      case 'all':
        startDate = moment().subtract(100, 'years'); // All time
        break;
      case '120':
        startDate = moment().subtract(120, 'days');
        break;
      case '90':
        startDate = moment().subtract(90, 'days');
        break;
      case '60':
        startDate = moment().subtract(60, 'days');
        break;
      case '30':
        startDate = moment().subtract(30, 'days');
        break;
      case '7':
        startDate = moment().subtract(7, 'days');
        break;
      default:
        startDate = moment().subtract(30, 'days');
        break;
    }

    this.datePicker = { 
      startDate: startDate, 
      endDate: endDate 
    };

    // Update form values
    this.statementForm.patchValue({
      startDate: startDate.toDate(),
      endDate: endDate.toDate()
    });
  }

  onDateRangeSelection(event: any) {
    this.setDateRange(event.value);
  }

  generate() {
    if (!this.datePicker) {
      this.datePicker = { 
        startDate: moment().subtract(30, 'days'), 
        endDate: moment() 
      };
    }

    // Get values from the form
    const startDateValue = this.statementForm.get('startDate')!.value;
    const endDateValue = this.statementForm.get('endDate')!.value;
  
    // Convert to moment objects if they are not already
    this.datePicker.startDate = moment.isMoment(startDateValue) ? startDateValue : moment(startDateValue);
    this.datePicker.endDate = moment.isMoment(endDateValue) ? endDateValue : moment(endDateValue);

    if(this.datePicker.startDate.isSameOrBefore(this.datePicker.endDate)){
      this.dialogRef.close({
        startDate: this.datePicker.startDate.toDate(),
        endDate: this.datePicker.endDate.toDate(),
        vatExclusive: this.statementForm.get('vatExclusive')?.value === true,
      });
    }else{
      this.showToastMessage('Start date must be before the end date')
    }
  }

  close() {
    this.dialogRef.close();
  }

  initForm(){
    this.statementForm = this.fb.group({
      startDate: [moment().subtract(30, 'days').toDate(), Validators.required],
      endDate: [moment().toDate(), Validators.required],
      vatExclusive: [false],
    });
  }
}
